import styled from 'styled-components';

export const ChecksContainer = styled.div`
  align-items: center;
  display: flex;
  gap: 22px;
  height: 100%;
`;
